import React from 'react';
import { Emoji } from 'emoji-mart';
import styled from 'styled-components';

const FilterBox = styled.div`
  user-select: none;
  border-radius: 30px;
  padding: 10px 15px 10px 18px;
  border: solid rgba(0, 0, 0, 0.07) 1px;
  color: ${props => props.theme.secondaryTextColor};
  min-width: 60px;
  min-width: 100px;
  text-align: center;
  cursor: pointer;
  ${props =>
    !props.disabled &&
    `
  background: #F3F5F6;
  border: solid rgba(0, 0, 0, 0.0) 1px;
  `}
`;

export default ({ setFilter, filter, item, ...other }) => {
  const handleFilters = () => {
    return filter === item.value ? setFilter(null) : setFilter(item.value);
  };

  return (
    <FilterBox onClick={handleFilters} id={item.value} {...other} disabled={filter !== item.value}>
      <Emoji emoji={item.emoji} set="apple" size={16} />  {item.value}
    </FilterBox>
  );
};
